export default {
  // ========== CustomFab - Tooltips ==========
  navigateTo: 'Navegar a',
  studyPlan: 'Plan de Estudio',
  curricularMesh: 'Malla Curricular',
  evaluations: 'Evaluaciones',
  assessmentByStudent: 'Assessment por Estudiante',
  assessmentReport: 'Reporte de Assessment',
  assessmentOf: 'Assessment de la',
  gradingCenter: 'Centro de Calificaciones',
  grades: 'Notas',
  gradesOf: 'Notas de la',
  progression: 'Progresión de',
  progressionOf: 'Progresión de las',
  pdaTeacher: 'PDA Docente',
  paStudent: 'PA Estudiante',
  of: 'de la',
  matterDescription: 'Descripción Asignatura',
  evaluation: 'Evaluación',
  learningExperiences: 'Experiencias de Aprendizaje',
  pia: 'PIA',
}
